export const ALLOWED_FILE_TYPES = ['image/jpeg', 'video/mp4', 'video/quicktime', 'application/postscript'];
